import React from 'react';
import PropTypes from 'prop-types';
import '../../../styles/scss/filters/input.scss';

const Input = (props) => {
  const { className, label, value, onChange } = props;
  return (
    <div className={`input-wrapper ${className}`}>
      <div className="inner-input-container">
        <div className="inner-input-container__days">
          <input onChange={(e) => onChange(e.target.value)} value={value} />
          {label}
        </div>
      </div>
    </div>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default Input;
